"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const loQueTeLlevas = ["Hallazgos críticos de la operación, con evidencia concreta de cada uno.", "Arquitectura recomendada, con justificación de cada decisión.", "Roadmap por fases, priorizado y con dependencias mapeadas.", "Estimación de inversión por fase, con rango y supuestos explícitos."];
export default function EntregablesYCobranza() {
  return <>
      <BloqueLoQueTeLlevas />
      <BloqueComoCobramos />
    </>;
}
function BloqueLoQueTeLlevas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="diagnostico-entregables" id="lo-que-te-llevas" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-8">
            Lo que te llevas.
          </h2>

          <p className="font-sans text-lg text-muted-foreground leading-relaxed mb-10 max-w-2xl">
            Un documento ejecutivo que contiene:
          </p>

          <ul className="space-y-5 mb-10 max-w-2xl">
            {loQueTeLlevas.map((item, i) => <li key={i} className="flex gap-4 font-sans text-base md:text-lg text-foreground/90 leading-relaxed">
                <span className="font-mono text-primary text-sm mt-1.5 shrink-0">
                  ·
                </span>
                <span>{item}</span>
              </li>)}
          </ul>

          <p className="font-sans text-base md:text-lg italic text-muted-foreground leading-relaxed max-w-2xl">El documento es tuyo. Si decides ejecutarlo con otro proveedor, con tu equipo interno, o no ejecutarlo, te lo quedas igual.</p>
        </div>
      </div>
    </section>;
}
function BloqueComoCobramos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="diagnostico-cobranza" id="como-cobramos" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-10">
            Cómo cobramos.
          </h2>

          <div className="space-y-6 font-sans text-lg md:text-xl text-foreground/90 leading-relaxed max-w-2xl">
            <p>Inversión fija acordada antes de empezar. No por hora.</p>

            <p>Si después del Diagnóstico decides continuar con Fulcro Partner, <span className="text-primary" data-ast-id="f:/src/pages/Diagnostico/sections/DetailedServiceList.tsx|sig:p8yc2l" data-ast-start="3025" data-ast-end="3155">el 50% del Diagnóstico se acredita al primer mes de Partner.</span></p>

            <p className="text-muted-foreground italic">Si decides ejecutar in-house o con otro proveedor, el documento queda igual y no hay obligación de seguir.</p>
          </div>
        </div>
      </div>
    </section>;
}